import createAction from '../../common/services/create-action';

export const LOAD_RCE = 'app/LOAD_RCE';

export const loadRCE = createAction(LOAD_RCE);
